export default "__VITE_ASSET__5924c5a1__"